import React from "react";
import { useTranslation } from "react-i18next";
import AppTable from "../../../../shared/AppTable";
import ValidationErrors from "../../../../components/ValidationErrors";

function CareTeamsTable({ data, loading }) {
  const { t } = useTranslation();
  const hasValidation = (row) =>
    row?.has_validation_error === true ||
    (Array.isArray(row?.validation_errors) && row.validation_errors.length > 0);

  const columns = [
    {
      header: t("Sequence"),
      render: (row, index) => row?.sequence_no ?? index + 1,
    },
    {
      header: t("Name"),
      render: (row) => (
        <span className="font-semibold text-[#0070C2] text-xs">
          {row?.name || "--"}
        </span>
      ),
    },
    { header: t("Practitioner Role"), field: "practitioner_role" },
    { header: t("Care Team Role"), field: "care_team_role" },
    { header: t("Qualification"), field: "qualification" },
    { header: t("Speciality"), field: "speciality" },
  ];

  return (
    <>
      <AppTable
        columns={columns}
        data={data?.data?.care_teams || []}
        loading={loading}
        actions={false}
        renderRowBelow={(row) =>
          hasValidation(row) ? (
            <ValidationErrors validationErrors={row.validation_errors} compact />
          ) : null
        }
        getRowSx={(row) => ({
          backgroundColor: hasValidation(row) ? "#FEF3C7" : "transparent",
          "&:hover": {
            backgroundColor: hasValidation(row)
              ? "#FDE68A !important"
              : "rgba(0, 0, 0, 0.04)",
          },
        })}
      />
    </>
  );
}

export default CareTeamsTable;
